import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { Typography, CardActionArea } from "@mui/material";
import { IndicateBlub, CircleButton, IncDecBtn, Remote } from "../atoms/index";
import { CardTitle } from "../../Pages/Audio/style";
import Info from "../../../assets/Icons/Info.png";
import PowerRed from "../../../assets/Icons/PowerRed.png";
import InputSource from "../../../assets/Icons/InputSourceWhite.png";
import Menu from "../../../assets/Icons/Menu.png";
import KeypadWhite from "../../../assets/Icons/KeypadWhite.png";
import ReturnWhite from "../../../assets/Icons/ReturnWhite.png";
import ArrowUp from "../../../assets/Icons/Arrow Up-01.png";
import ToolsWhite from "../../../assets/Icons/ToolsWhite.png";
import MuteWhite from "../../../assets/Icons/Mute White.png";
import ArrowDown from "../../../assets/Icons/Down Arrow White 7.png";
import Plus from "../../../assets/Icons/Plus-01.png";
import Minus from "../../../assets/Icons/Minus-01.png";
import Home from "../../../assets/Icons/Home White.png";
import "./index.css";
type VideoProps = {
  title: string;
  projectorRemote: boolean;
};

const VideoRemote = ({ title, projectorRemote }: VideoProps) => {
  const [blubLight, setBlubLight] = useState<boolean>(false);
  const handlePower = () => {
    setBlubLight(!blubLight);
  };
  const handleBlink = () => {
    setBlubLight(false);
    setTimeout(() => {
      setBlubLight(true);
    }, 200);
  };
  return (
    <div>
      <Grid container>
        <Grid md={12}>
          <Paper className="paper-width" elevation={3}>
            {/* title and buld */}
            <Box className="flexom">
              <Typography sx={CardTitle}>{title}</Typography>
              <IndicateBlub toggleTheBulb={blubLight} />
            </Box>
            {/* power buttons */}
            <Box>
              <div className="grid-container">
                {/* above buttons */}
                <CardActionArea className="grid-item" onClick={handlePower}>
                  <CircleButton image={PowerRed} text={"Power"} alpha={true} />
                </CardActionArea>
                <CardActionArea
                  onClick={blubLight ? handleBlink : undefined}
                  className="grid-item"
                >
                  <CircleButton
                    image={InputSource}
                    text={"Input Source"}
                    alpha={true}
                  />
                </CardActionArea>
                <CardActionArea
                  onClick={blubLight ? handleBlink : undefined}
                  className="grid-item"
                >
                  <CircleButton image={Info} text={"Info"} alpha={true} />
                </CardActionArea>
                <CardActionArea
                  onClick={blubLight ? handleBlink : undefined}
                  className="grid-item"
                >
                  <CircleButton image={Menu} text={"Menu"} alpha={true} />
                </CardActionArea>
                <CardActionArea
                  onClick={blubLight ? handleBlink : undefined}
                  className="grid-item"
                >
                  <CircleButton
                    image={KeypadWhite}
                    text={"Numeric Buttons"}
                    alpha={true}
                  />
                </CardActionArea>
                <CardActionArea
                  onClick={blubLight ? handleBlink : undefined}
                  className="grid-item"
                >
                  <CircleButton
                    image={ReturnWhite}
                    text={"Return"}
                    alpha={true}
                  />
                </CardActionArea>
              </div>
            </Box>

            {/* togller */}
            {projectorRemote ? (
              <Box sx={{ mt: 2 }}>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-evenly"
                  alignItems="center"
                >
                  <div>
                    <IncDecBtn
                      handleBlink={blubLight ? handleBlink : undefined}
                      image={ArrowUp}
                      imagetwo={ArrowDown}
                      text={"Channel"}
                      alpha={true}
                    />
                  </div>
                  <div>
                    <IncDecBtn
                      handleBlink={blubLight ? handleBlink : undefined}
                      image={Plus}
                      imagetwo={Minus}
                      text={"Volume"}
                      alpha={true}
                    />
                  </div>
                  <div>
                    <IncDecBtn
                      handleBlink={blubLight ? handleBlink : undefined}
                      image={Plus}
                      imagetwo={Minus}
                      text={"Volume"}
                      alpha={true}
                    />
                  </div>
                  <div>
                    <IncDecBtn
                      handleBlink={blubLight ? handleBlink : undefined}
                      image={Plus}
                      imagetwo={Minus}
                      text={"Volume"}
                      alpha={true}
                    />
                  </div>
                </Grid>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "28px",
                  }}
                >
                  <div>
                    <Remote
                      fly={""}
                      handleBlink={blubLight ? handleBlink : undefined}
                    />
                  </div>
                </div>
              </Box>
            ) : (
              <Box>
                {/* channel buttons */}
                <Box sx={{ mt: 2, mb: 12 }}>
                  <Grid container>
                    <Grid lg={4} md={4} sm={4} xs={4}>
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <IncDecBtn
                          handleBlink={blubLight ? handleBlink : undefined}
                          image={ArrowUp}
                          imagetwo={ArrowDown}
                          text={"Channel"}
                          alpha={true}
                        />
                      </Box>
                    </Grid>
                    <Grid lg={4} md={4} sm={4} xs={4}>
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <CircleButton
                          handleBlink={blubLight ? handleBlink : undefined}
                          image={Home}
                          text={"Home"}
                          alpha={false}
                        />
                      </Box>
                    </Grid>
                    <Grid lg={4} md={4} sm={4} xs={4}>
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <IncDecBtn
                          handleBlink={blubLight ? handleBlink : undefined}
                          image={Plus}
                          imagetwo={Minus}
                          text={"Volume"}
                          alpha={true}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                {/* circular remote here */}
                <Box sx={{ mt: 2, pb: 5, pt: 6 }}>
                  <Grid container>
                    <Grid lg={4} md={4} sm={4} xs={4}>
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <CircleButton
                          handleBlink={blubLight ? handleBlink : undefined}
                          image={ToolsWhite}
                          text={"Tools"}
                          alpha={false}
                        />
                      </Box>
                    </Grid>
                    <Grid lg={4} md={4} sm={4} xs={4}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        <Remote
                          handleBlink={blubLight ? handleBlink : undefined}
                          fly={"fly"}
                        />
                      </Box>
                    </Grid>
                    <Grid lg={4} md={4} sm={4} xs={4}>
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <CircleButton
                          handleBlink={blubLight ? handleBlink : undefined}
                          image={MuteWhite}
                          text={"Mute"}
                          alpha={false}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default VideoRemote;
